(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Collection search functionality - Filter products on current page
  document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.mt-collection-filter-button-wrapper');
    if (!wrapper) return;
    
    const sectionId = wrapper.dataset.sectionId;
    const searchInput = document.getElementById('mt-collection-search-input-' + sectionId);
    const searchForm = wrapper.querySelector('.mt-collection-search-form');
    const clearButton = searchForm?.querySelector('.mt-collection-search-clear');

    if (!searchInput || !searchForm) return;

    // Get all product items in the current page
    const getProductItems = () => {
      return document.querySelectorAll('.product-grid__item');
    };

    // Store original pagination display state
    const pagination = document.querySelector('.product-grid-pagination');
    const originalPaginationDisplay = pagination ? window.getComputedStyle(pagination).display : 'none';

    // Get or create "No product found" message element
    const productGrid = document.querySelector('.product-grid');
    let noProductMessage = document.querySelector('.mt-collection-no-product-message');
    
    if (!noProductMessage) {
      // Find the container that holds the product grid
      const gridContainer = productGrid ? productGrid.closest('div[class*="grid"], div[class*="container"]') : null;
      const insertTarget = gridContainer || (productGrid ? productGrid.parentNode : null);
      
      if (insertTarget) {
        noProductMessage = document.createElement('div');
        noProductMessage.className = 'mt-collection-no-product-message';
        noProductMessage.style.cssText = 'text-align: center; padding: 40px 20px; display: none; grid-column: 1 / -1;';
        noProductMessage.innerHTML = '<p style="font-size: 16px; color: #5D5F69; margin: 0;">No product found.</p>';
        
        // Insert after product grid if it exists, otherwise append to container
        if (productGrid && productGrid.parentNode) {
          productGrid.parentNode.insertBefore(noProductMessage, productGrid.nextSibling);
        } else {
          insertTarget.appendChild(noProductMessage);
        }
      }
    }

    // Filter products based on search term
    const filterProducts = (searchTerm) => {
      const term = searchTerm.toLowerCase().trim();
      const productItems = getProductItems();
      let visibleCount = 0;

      productItems.forEach((item) => {
        // Try multiple selectors to find product title
        // First try product-title element, then various other common selectors
        const productTitleEl = item.querySelector('product-title, [data-product-title], .product-card__title, h3, .card__heading, .card__title, [class*="product-title"], [class*="title"]');
        
        // If not found, try to get title from product card link's aria-label or visually-hidden span
        let productTitleText = '';
        if (productTitleEl) {
          productTitleText = (productTitleEl.textContent || productTitleEl.innerText || '').toLowerCase().trim();
        } else {
          // Fallback: try to get from product-card link's visually-hidden span or aria-label
          const productCardLink = item.querySelector('.product-card__link');
          if (productCardLink) {
            const visuallyHidden = productCardLink.querySelector('.visually-hidden');
            if (visuallyHidden) {
              productTitleText = (visuallyHidden.textContent || visuallyHidden.innerText || '').toLowerCase().trim();
            } else if (productCardLink.getAttribute('aria-label')) {
              productTitleText = productCardLink.getAttribute('aria-label').toLowerCase().trim();
            }
          }
        }

        // If still no title found, show all items when search is empty
        if (!productTitleText) {
          item.style.display = term ? 'none' : '';
          if (!term) visibleCount++;
          return;
        }

        const shouldShow = !term || productTitleText.includes(term);
        
        item.style.display = shouldShow ? '' : 'none';
        if (shouldShow) visibleCount++;
      });

      // Show/hide "No product found" message
      if (noProductMessage) {
        if (term && visibleCount === 0) {
          noProductMessage.style.display = 'block';
        } else {
          noProductMessage.style.display = 'none';
        }
      }

      // Update pagination visibility based on visible products count
      // Products per page is 24, so hide pagination if visible products <= 24
      if (pagination) {
        if (term && visibleCount <= 24) {
          // Hide pagination when search results are less than or equal to one page
          pagination.style.display = 'none';
        } else if (!term) {
          // Restore original pagination visibility when search is cleared
          pagination.style.display = originalPaginationDisplay;
        } else {
          // Show pagination if search results exceed one page
          pagination.style.display = originalPaginationDisplay === 'none' ? 'none' : '';
        }
      }

      // Update URL without page reload
      const url = new URL(window.location.href);
      if (term) {
        url.searchParams.set('q', term);
      } else {
        url.searchParams.delete('q');
      }
      window.history.replaceState({}, '', url);

      // Show/hide clear button
      if (clearButton) {
        clearButton.style.display = term ? 'flex' : 'none';
      }
    };

    // Handle form submission - prevent default and filter instead
    searchForm.addEventListener('submit', (e) => {
      e.preventDefault();
      filterProducts(searchInput.value);
    });

    // Handle clear button
    if (clearButton) {
      clearButton.addEventListener('click', (e) => {
        e.preventDefault();
        searchInput.value = '';
        filterProducts('');
        searchInput.focus();
      });
    }

      searchInput.addEventListener('click', () => {
        if (wrapper) {
          if (typeof wrapper.scrollIntoViewIfNeeded === 'function') {
            wrapper.scrollIntoViewIfNeeded();
          } else {
            wrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      });

      let searchTimeout;
      searchInput.addEventListener('input', () => {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
          filterProducts(searchInput.value);
        }, 300);
      });

    const urlParams = new URLSearchParams(window.location.search);
    const urlSearchTerm = urlParams.get('q');
    if (urlSearchTerm) {
      searchInput.value = urlSearchTerm;
      filterProducts(urlSearchTerm);
    }

    // Also check if clear button should be visible initially
    if (clearButton) {
      clearButton.style.display = urlSearchTerm ? 'flex' : 'none';
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-video-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.MtVideoTextInit) return;
    window.MtVideoTextInit = true;

    function getActiveMedia(container) {
      const isMobile = window.innerWidth <= 749;
      const desktopVideoWrapper = container.querySelector('.mt-video-text__video-desktop');
      const mobileVideoWrapper = container.querySelector('.mt-video-text__video-mobile');

      let videoEl = null;
      let iframeEl = null;

      if (isMobile && mobileVideoWrapper) {
        videoEl = mobileVideoWrapper.querySelector('video[data-mt-video-el]');
        iframeEl = mobileVideoWrapper.querySelector('[data-mt-video-iframe]');
      } else if (!isMobile && desktopVideoWrapper) {
        videoEl = desktopVideoWrapper.querySelector('video[data-mt-video-el]');
        iframeEl = desktopVideoWrapper.querySelector('[data-mt-video-iframe]');
      }

      if (!videoEl && !iframeEl) {
        videoEl = container.querySelector('video[data-mt-video-el]');
        iframeEl = container.querySelector('[data-mt-video-iframe]');
      }

      return { videoEl, iframeEl };
    }

    function scheduleAutoplay(container) {
      const { videoEl, iframeEl } = getActiveMedia(container);

      if (videoEl) {
        try {
          videoEl.pause();
        } catch (e) {
          /* ignore */
        }

        setTimeout(function() {
          videoEl.play().catch(function() {
            /* autoplay may be blocked; ignore */
          });
        }, 2000);
      } else if (iframeEl) {
        const autoplaySrc = iframeEl.getAttribute('data-autoplay-src');
        const baseSrc = iframeEl.getAttribute('data-base-src');

        if (baseSrc && !iframeEl.dataset.mtBaseApplied) {
          iframeEl.setAttribute('src', baseSrc);
          iframeEl.dataset.mtBaseApplied = 'true';
        }

        if (autoplaySrc) {
          setTimeout(function() {
            iframeEl.setAttribute('src', autoplaySrc);
          }, 2000);
        }
      }
    }

    function updatePlayButtonState(playButton, isPlaying) {
      const playIcon = playButton.querySelector('.mt-video-text__play-icon');
      const pauseIcon = playButton.querySelector('.mt-video-text__pause-icon');
      
      if (isPlaying) {
        playButton.classList.add('is-playing');
        if (playIcon) playIcon.style.display = 'none';
        if (pauseIcon) pauseIcon.style.display = 'block';
        playButton.setAttribute('aria-label', 'Pause video');
      } else {
        playButton.classList.remove('is-playing');
        if (playIcon) playIcon.style.display = 'block';
        if (pauseIcon) pauseIcon.style.display = 'none';
        playButton.setAttribute('aria-label', 'Play video');
      }
    }

    document.addEventListener('click', function(event) {
      const playButton = event.target.closest('[data-mt-video-play]');
      if (!playButton) return;

      const container = playButton.closest('.mt-video-text');
      if (!container) return;

      // Find visible video (mobile or desktop)
      const desktopVideoWrapper = container.querySelector('.mt-video-text__video-desktop');
      const mobileVideoWrapper = container.querySelector('.mt-video-text__video-mobile');
      
      let videoEl = null;
      let iframeEl = null;
      
      // Check which video wrapper is visible
      const isMobile = window.innerWidth <= 749;
      if (isMobile && mobileVideoWrapper) {
        videoEl = mobileVideoWrapper.querySelector('video[data-mt-video-el]');
        iframeEl = mobileVideoWrapper.querySelector('[data-mt-video-iframe]');
      } else if (!isMobile && desktopVideoWrapper) {
        videoEl = desktopVideoWrapper.querySelector('video[data-mt-video-el]');
        iframeEl = desktopVideoWrapper.querySelector('[data-mt-video-iframe]');
      }
      
      // Fallback: find any video if specific wrapper not found
      if (!videoEl && !iframeEl) {
        videoEl = container.querySelector('video[data-mt-video-el]');
        iframeEl = container.querySelector('[data-mt-video-iframe]');
      }

      if (videoEl) {
        if (videoEl.paused) {
          videoEl.play();
          updatePlayButtonState(playButton, true);
        } else {
          videoEl.pause();
          updatePlayButtonState(playButton, false);
        }
      } else if (iframeEl) {
        const autoplaySrc = iframeEl.getAttribute('data-autoplay-src');
        if (autoplaySrc && iframeEl.getAttribute('src').indexOf('autoplay=1') === -1) {
          iframeEl.setAttribute('src', autoplaySrc);
          updatePlayButtonState(playButton, true);
        }
      }
    });

    // Listen for video play/pause events to update button state
    document.querySelectorAll('video[data-mt-video-el]').forEach(function(videoEl) {
      const container = videoEl.closest('.mt-video-text');
      if (!container) return;
      const playButton = container.querySelector('[data-mt-video-play]');
      if (!playButton) return;

      // Set initial state based on video autoplay
      if (videoEl.autoplay && !videoEl.paused) {
        updatePlayButtonState(playButton, true);
      }

      videoEl.addEventListener('play', function() {
        updatePlayButtonState(playButton, true);
      });

      videoEl.addEventListener('pause', function() {
        updatePlayButtonState(playButton, false);
      });

      videoEl.addEventListener('ended', function() {
        // Video will loop, so keep playing state
        updatePlayButtonState(playButton, true);
      });
    });

    // Set initial state for iframe videos (they autoplay by default)
    document.querySelectorAll('[data-mt-video-iframe]').forEach(function(iframeEl) {
      const container = iframeEl.closest('.mt-video-text');
      if (!container) return;
      const playButton = container.querySelector('[data-mt-video-play]');
      if (!playButton) return;
      
      // If iframe has autoplay in src, set button to playing state
      if (iframeEl.getAttribute('src').indexOf('autoplay=1') !== -1) {
        updatePlayButtonState(playButton, true);
      }
    });

    // Auto play after showing cover for 2 seconds
    document.querySelectorAll('.mt-video-text').forEach(function(container) {
      scheduleAutoplay(container);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
